import styled from 'styled-components';
import { green } from 'utils/style/colors';

export const Thumb = styled.a<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border: 1px solid ${green};
  padding: 2px;
  display: inline-flex;
  box-sizing: border-box;
  border-radius: 10px;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 10px;
`;

export const ThumbInner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
`;
